import { memo } from 'react';
import { ProgramAchievementGraphicKey } from 'ShareableGraphics/ShareableGraphics.types';
import { Text } from 'Text';
import { useTranslation } from 'react-i18next';
import { ProgramAchievementMessage } from '../ProgramAchievementMessage';

function AcceptedMessageComponent() {
    const { t } = useTranslation('back_royal', { keyPrefix: 'acceptedMessage' });
    return (
        <ProgramAchievementMessage variant={ProgramAchievementGraphicKey.accepted}>
            <Text as="div" color="black" weight="normal" className="hidden sm:block">
                {t('desktopMessage')}
            </Text>
            <Text as="div" color="black" weight="normal" className="block sm:hidden">
                {t('mobileMessage')}
            </Text>
        </ProgramAchievementMessage>
    );
}

export const AcceptedMessage = memo(AcceptedMessageComponent) as unknown as typeof AcceptedMessageComponent;
